import { TableData } from '@/components/TableData/TableData';
import { TableSearch } from '@/components/TableSearch/TableSearch';
import TableLayout from '@/layouts/TableLayout/TableLayout';
import { useSellerViewController } from './SellerViewController';
import { itemGenerator } from './TableItem';

export function SellerContainer() {
  const { uiState, actions } = useSellerViewController();

  return (
    <TableLayout
      isLoading={uiState.isLoading}
      header={
        <TableSearch
          searchText={uiState.searchQuery}
          onChange={actions.onSearchChanged}
          hint="Buscar por nombre del vendedor"
          isSearching={uiState.isSearching}
        />
      }
      body={
        <>
          <TableData
            columnHeaders={uiState.columnHeaders}
            items={uiState.items}
            rowItemGenerator={itemGenerator}
            paging={uiState.paging}
            onPageSelected={actions.onPageRequested}
            roundedTop={true}
            compact={true}
            onRowClick={actions.onSellerSelected}
          />
        </>
      }
    />
  );
}
